import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import TopNav from '../../components/TopNav'
import LoadError from '../../components/LoadError'
import useCustomerList from '../../utils/useCustomerList'
import { getMemoryState } from '../../api'
import './MemoryViewer.css'

export default function MemoryViewer() {
  const { customers, error: customersError, reload: reloadCustomers } = useCustomerList(list => {
    if (list.length > 0) setCustomerId(list[0].customer_id)
  })
  const [customerId, setCustomerId] = useState('')
  const [memory, setMemory] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!customerId) return
    setLoading(true)
    getMemoryState(customerId)
      .then(data => setMemory(data))
      .catch(() => setMemory(null))
      .finally(() => setLoading(false))
  }, [customerId])

  const breadcrumbs = [{ label: 'Admin', href: '/admin' }, { label: 'Memory Viewer' }]

  function renderSection(title, data) {
    if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) return null
    return (
      <div className="mv-section">
        <h3 className="mv-section-title">{title}</h3>
        <pre className="mv-json">{JSON.stringify(data, null, 2)}</pre>
      </div>
    )
  }

  return (
    <>
      <TopNav breadcrumbs={breadcrumbs} actions={
        <><Link to="/admin" className="nav-btn">Dashboard</Link></>
      } />
      <div className="mv-page">
        <div className="mv-header">
          <h1 className="mv-title">Memory Viewer</h1>
          <select className="mv-select" value={customerId} onChange={e => setCustomerId(e.target.value)}>
            {customers.map(c => <option key={c.customer_id} value={c.customer_id}>{c.company_name}</option>)}
          </select>
        </div>
        {customersError && <LoadError what="customers" error={customersError} onRetry={reloadCustomers} />}

        {loading ? (
          <div className="mv-loading"><div className="mv-spinner" /><p>Loading memory state…</p></div>
        ) : memory ? (
          <div className="mv-content">
            {renderSection('Session Memory', memory.session)}
            {renderSection('Project Memory', memory.project)}
            {renderSection('Global Memory', memory.global)}
            {!memory.session && !memory.project && !memory.global && (
              <div className="mv-empty">No memory state found for this customer.</div>
            )}
          </div>
        ) : (
          <div className="mv-empty">Select a customer to view memory state.</div>
        )}
      </div>
    </>
  )
}
